import React from "react";

const NestjsIco = (props) => {
  return (
    <svg {...props} viewBox="0 0 48 48">
      <path
        fill="inherit"
        d="M45.963,23.959C34.056,23.489,24.51,13.944,24.041,2.037L24,1l-0.041,1.037	C23.49,13.944,13.944,23.489,2.037,23.959L1,24l1.037,0.041c11.907,0.47,21.452,10.015,21.922,21.922L24,47l0.041-1.037	c0.47-11.907,10.015-21.452,21.922-21.922L47,24L45.963,23.959z"
      ></path>
    </svg>
  );
};
export default NestjsIco;
